import * as React from 'react';
import _ from 'lodash';
import emailSpellChecker from '@zootools/email-spell-checker';

import Anchor from 'components/Anchor';
import BaseComponent from '@tock/shared/components/BaseComponent';
import Field from '@tock/shared/components/forms/Field';
import TextInput from '@tock/shared/components/inputs/DeprecatedTextInput';

interface Props {
  'data-testid'?: string;
  autoComplete?: boolean;
  email: ReduxFormField<string>;
  disabled?: boolean;
  onAdvanceToNextField?(): void;
  emailInput: React.RefObject<TextInput>;
  placeholder?: string;
}

interface State {
  suggestion: string | null;
}

class EmailField extends BaseComponent<Props, State> {
  static defaultProps: Partial<Props> = {
    autoComplete: true,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      suggestion: null,
    };
  }

  handleEmailChange() {
    const emailValue = this.props.email.value;
    this.fireMailCheckSuggestion(emailValue);
  }

  private fireMailCheckSuggestion(emailValue: string) {
    const suggestion = emailSpellChecker.run({ email: emailValue });
    if (suggestion) {
      this.setState({ suggestion: suggestion.full });
    } else {
      this.resetSuggestion();
    }
  }

  handleUseMailcheckSuggestion(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    const { suggestion } = this.state;
    const { onAdvanceToNextField, email } = this.props;

    email.onChange(suggestion as string);
    this.resetSuggestion();
    if (_.isFunction(onAdvanceToNextField)) {
      onAdvanceToNextField();
    }
  }

  resetSuggestion() {
    this.setState({
      suggestion: null,
    });
  }

  render() {
    const { suggestion } = this.state;
    const { autoComplete, email, disabled, emailInput, placeholder } = this.props;

    const mailcheckSuggestion = suggestion ? (
      <span>
        Did you mean{' '}
        <Anchor href="#" onClick={this.handleUseMailcheckSuggestion}>
          {suggestion}
        </Anchor>
        ?
      </span>
    ) : undefined;

    return (
      <Field
        label="Email address"
        labelFor="email"
        field={email}
        error={mailcheckSuggestion}
        key="EmailField"
      >
        <TextInput
          data-testid={this.props['data-testid']}
          field={email}
          id="email"
          disabled={!!disabled}
          placeholder={placeholder ? placeholder : 'Email address'}
          autoComplete={autoComplete ? 'email' : undefined}
          ref={emailInput}
          type="email"
          onBlur={this.handleEmailChange}
          key="EmailTextInput"
        />
      </Field>
    );
  }
}
export default EmailField;
